import { styled } from "styled-components";

export const SourceAutocompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  transition: all 0.3s ease;
`;

export const SelectedSourcesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const Label = styled.label`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBright};
`;
